import Vue from 'vue'
import Vuex from 'vuex'
import authModule from './auth.module'
import accessPointModule from './accessPoint.module'
import accountmodule from './account.module'
import admin from './admin'
import appointment from './appointment'
import bucketHost from './bucketHost'
import customerModule from './customer.module'
import formModule from './form.module'
import formResultModule from './formResult.module'
import optimap from './optimap'
import account from './account'
import planModule from './plan.module'
import signup from './signup'
import searchModule from './search.module'
import signupModule from './signup.module'
import swModule from './sw.module'
import towerModule from './tower.module'
import userModule from './user.module'
import organization from './organization'
import publicModule from './public.module'
import persist from './persist'
import pubreport from './pubreport/pubreport.module'
import { NotUnique } from '@/errors/bucketErrors.js'

import ApiService from '../services/api.service'

import { _COMMIT_LOG, _DOWNLOAD_INVOICE, AUTH_LOGOUT } from './actions.types'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    serverURL: '',
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: 'https://demos.creative-tim.com/material-dashboard/assets/img/sidebar-1.jpg',
    drawer: null,
    activePage: '',
    drawerFilterSearch: false,
    months: [
      {
        text: '01',
        value: 1,
      },
      {
        text: '02',
        value: 2,
      },
      {
        text: '03',
        value: 3,
      },
      {
        text: '04',
        value: 4,
      },
      {
        text: '05',
        value: 5,
      },
      {
        text: '06',
        value: 6,
      },
      {
        text: '07',
        value: 7,
      },
      {
        text: '08',
        value: 8,
      },
      {
        text: '09',
        value: 9,
      },
      {
        text: '10',
        value: 10,
      },
      {
        text: '11',
        value: 11,
      },
      {
        text: '12',
        value: 12,
      },
    ],
    years: [
      {
        text: '2024',
        value: 2024,
      },
      {
        text: '2025',
        value: 2025,
      },
      {
        text: '2026',
        value: 2026,
      },
      {
        text: '2027',
        value: 2027,
      },
      {
        text: '2028',
        value: 2028,
      },
      {
        text: '2029',
        value: 2029,
      },
      {
        text: '2030',
        value: 2030,
      },
    ],
    billingFreq: [
      {
        text: 'Monthly',
        value: 1,
      },
      {
        text: 'Semi-Annual',
        value: 6,
      },
      {
        text: 'Annual',
        value: 12,
      },
    ],
    stores: [
      {
        text: 'Velociter',
        value: 1,
      },
      {
        text: 'ezWave',
        value: 2,
      },
    ],
    isDebugMode: true,

  },
  mutations: {
    SET_BAR_IMAGE (state, payload) {
      state.barImage = payload
    },
    SET_DRAWER (state, payload) {
      state.drawer = payload
    },
    SET_DRAWER_FILTER_SEARCH (state, payload) {
      state.drawerFilterSearch = payload
    },
    SET_ACTIVE_PAGE (state, payload) {
      state.activePage = payload
    },
  },
  actions: {
    // Process Axios Error
    async processAxiosError ({ dispatch, commit, rootState, getters }, payload) {
      dispatch(_COMMIT_LOG, 'Processing Error Response...')
      if (payload.response) {
        const { data, status, headers } = payload.response
        dispatch(_COMMIT_LOG, { message: 'Error Data:', data })
        dispatch(_COMMIT_LOG, { message: 'Error Status:', status })
        dispatch(_COMMIT_LOG, { message: 'Error Headers:', headers })
        if (status === 401) {
          await dispatch(AUTH_LOGOUT)
        } else if (status === 400 && data) {
          dispatch(_COMMIT_LOG, 'received 400 error')
          return data
        } else if (status === 403 && data) {
          return data
        } else if (status === 409 && data) {
          const errorData = data
          if (errorData.err_code === 'not_unique') {
            return new NotUnique(errorData)
          }
          return payload.response.data
        } else {
          dispatch(_COMMIT_LOG, { message: 'Skipped other errors, custom processing...', data, force: true })
          if (data) {
            if (data.http_code > 0 && data.problems && data.problems.length > 0) {
              return data
            }
          }
          return payload.response
        }
      } else {
        return payload
      }
    },
    [_COMMIT_LOG] ({ dispatch, commit, rootState, state, getters }, payload) {
      if (typeof payload === 'object' &&
          payload.force) {
        console.log(payload)
      } else if (getters.isDebugMode) {
        console.log(payload)
      }
    },
    /***
     * Get PDF of invoice
     * @param context
     * @param {string} payload.filename name to use for the file
     * @param {string} payload.account_key account GUID to download invoice for
     * @param {string} payload.invoice_key invoice_key (int for plat) to retrieve
     * @returns {Promise<*>}
     */
    async [_DOWNLOAD_INVOICE] (context, payload) {
      const { dispatch } = context
      // const student = state.currentStudent
      try {
        console.log(`Getting invoice PDF for account ${payload.account_key} and invoice: ${payload.invoice_key}`)
        // const newPayload = {
        //   student_rowkey: rowkey,
        // }
        let filename = payload.filename.replace(/[/\\?%*:|"<>]/g, '-') + '_' + new Date().getTime()
        filename = filename.replace(/[/\\.]/g, '')
        const params = {
          format: 'pdf',
        }
        const { data } = await ApiService.getArray('account', `${payload.account_key}/invoice/${payload.invoice_key}`, params)
        // console.log('Student Submissions returned:', data)
        const file = new File([data], filename, { lastModified: new Date().getTime(), type: 'application/pdf' })
        // const blob = new Blob([data], { type: 'application/pdf' })
        const a = document.createElement('a')
        document.body.appendChild(a)
        const blobUrl = window.URL.createObjectURL(file)
        a.href = blobUrl
        a.download = filename
        a.click()
        setTimeout(() => {
          window.URL.revokeObjectURL(blobUrl)
          document.body.removeChild(a)
        }, 0)
        // const url = window.URL.createObjectURL(file)
        // window.location.assign(url)
        // window.URL.revokeObjectURL(url)
        // window.open(url)
        // commit(STUDENT_SET_SUBMISSIONS, data)
        return data
        // const response = await axapi.post('/profile/', payload)
        // commit('UPDATE_PROFILE', data)
      } catch (e) {
        await dispatch('processAxiosError', e)
        console.log(e)
        throw e
      }
    },
  },
  getters: {
    isDebugMode: (state) => {
      const dbgString = `${process.env.VUE_APP_DEBUG}`
      return dbgString.toLowerCase() === 'true'// || state.isDebugMode
    },
    businessName: () => `${process.env.VUE_APP_BUSINESS_NAME}`,
    optsMonths: state => state.months,
    optsYears: state => state.years,
    optsStores: state => state.stores,
    optsBillingFreq: state => state.billingFreq,
    activePage: state => state.activePage,
  },
  modules: {
    module,
    account,
    accessPointModule,
    accountmodule,
    admin,
    authModule,
    appointment,
    bucketHost,
    customerModule,
    formModule,
    formResultModule,
    optimap,
    organization,
    planModule,
    pubreport,
    publicModule,
    searchModule,
    signup,
    signupModule,
    swModule,
    towerModule,
    userModule,
  },
  plugins: [persist.plugin],
})
